import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetBasesDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/basis/${id}`);
}

export function apiGetAllBases(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/bases`);
}

export function apiGetAllBasesByProduct(productId): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/bases/product/${productId}`);
}

export function apiCreateOrUpdateBasis(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/basiscreateorupdate`, data);
}

export function apiDeleteBasis(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/basis/${id}`);
}
